module.exports = __webpack_public_path__ + "media/images/sidekiq-163cf5a2bc68f61fa0386d7001942de7.svg";